import { Datepicker } from '../../components/Datepicker'
import { timelineYearFormat } from '../../components/Timelines/constants'
import moment from 'moment/moment'
import { ReactComponent as ArrowRight16 } from '../../assets/svg/ArrowRight16.svg'
import { ReactComponent as ArrowLeft16 } from '../../assets/svg/ArrowBack16.svg'
import { useCallback } from 'react'
import './styles.scss'
import { HealthSystemTable } from './Tables/HealthSystemTable'
import { CommunityTable } from './Tables/CommunityTable'
import { BTN_TXT } from '../../constants'
import { FloatFooter } from '../../components/FloatFooter/FloatFooter'
import { useSavingGoalsContext } from './Providers/SavingGolasContextProvider'
import HistoryGoals from './HistoryModal/HistoryGoals'
import { Tooltip } from '../../components/Tooltip/Tooltip'

export const SavingGoalsContainer = () => {
  const {
    state: { isSaveActive, period, disableTableActions, canSeeCommunityTable },
    actions: { onCancelEditing, onSaveAllData, setPeriod }
  } = useSavingGoalsContext()

  const getDisabledPeriod = useCallback((value) => {
    return (
      value.isBefore(moment().subtract(10, 'year')) ||
      value.isAfter(moment().add(10, 'year'))
    )
  }, [])

  return (
    <div className="saving-goals__container column gap-32">
      <Tooltip
        title={
          disableTableActions ? 'Period change is disabled in edit mode' : null
        }
      >
        <div className="saving-goals__container__period">
          <Datepicker
            propsDate={{
              format: timelineYearFormat,
              value: period,
              onChange: (date) => setPeriod(moment(date).startOf('year')),
              picker: 'year',
              superNextIcon: <ArrowRight16 />,
              superPrevIcon: <ArrowLeft16 />,
              disabledDate: getDisabledPeriod,
              disabled: disableTableActions
            }}
            propsItem={{
              label: 'Period'
            }}
          />
        </div>
      </Tooltip>
      {canSeeCommunityTable && <CommunityTable period={period} />}
      <HealthSystemTable period={period} />
      <HistoryGoals />
      <FloatFooter
        isActive={isSaveActive}
        onCancel={onCancelEditing}
        onSave={onSaveAllData}
        saveBtnText={BTN_TXT.SAVE}
      />
    </div>
  )
}
